export const DOUBLE_CLICK_TIME = 500;

// Speed when turning on the mouseEdges plugin for pixi-viewport
export const MOUSE_EDGES_SPEED = 8;
export const MOUSE_EDGES_DISTANCE = 20;
